module.exports = __webpack_public_path__ + "static/media/code.1ad74e6e.svg";